var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilePbiFilterCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6571 0.342857C15.2 -0.114286 14.5143 -0.114286 14.0571 0.342857L8 6.4L1.94286 0.342857C1.48571 -0.114286 0.8 -0.114286 0.342857 0.342857C-0.114286 0.8 -0.114286 1.48571 0.342857 1.94286L6.4 8L0.342857 14.0571C-0.114286 14.5143 -0.114286 15.2 0.342857 15.6571C0.571429 15.8857 0.8 16 1.14286 16C1.48571 16 1.71429 15.8857 1.94286 15.6571L8 9.6L14.0571 15.6571C14.2857 15.8857 14.6286 16 14.8571 16C15.0857 16 15.4286 15.8857 15.6571 15.6571C16.1143 15.2 16.1143 14.5143 15.6571 14.0571L9.6 8L15.6571 1.94286C16.1143 1.48571 16.1143 0.8 15.6571 0.342857Z",
    fill: "#7F8FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePbiFilterCloseIcon);
export default __webpack_public_path__ + "static/media/MobilePbiFilterCloseIcon.fa351ce7.svg";
export { ForwardRef as ReactComponent };